<template>
  <div class="gw">
    <!-- 走马灯图片 -->
    <el-carousel :interval="3000"
    trigger="click"
    :height="carHigh"
    :autoplay="isAutoPlay"
    @mouseenter.native="isAutoPlay = false"
    @mouseleave.native="isAutoPlay = true">
      <el-carousel-item v-for="(item, index) in listImgs" :key="index">
        <el-image style="width: 100%; height: 100%" fit="cover" :src="item.imgUrl"></el-image>
      </el-carousel-item>
    </el-carousel>

    <div class="sj-cpzx">
       产品中心 <span class="en-title">Product Center</span>
       <el-divider></el-divider>
    </div>
    <div class="sy-gywm">
      <el-row :gutter="3" justify="left" type="flex">
        <el-col :span="7" v-for="(pd, index) in products1" :key="index" :offset="index > 0 ? 1 : 0">
          <el-card :body-style="{ padding: '0px'}" style="margin-top:10px;" class="product-card">
            <el-image :src="pd.imgUrl" class="image" fit="cover" :preview-src-list="pd.srcList"></el-image>
            <div style="text-align:left;padding:10px">
              <span style="font-weight:600; font-size:16px;">{{pd.name}}</span>
              <el-button style="font-weight:600; font-size:15px;" type="text" class="button" @click="showCpDetail(pd)">详情</el-button>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-row :gutter="3" justify="letf" type="flex">
        <el-col :span="7" v-for="(product, index) in products2" :key="index" :offset="index > 0 ? 1 : 0">
          <el-card :body-style="{ padding: '0px'}" style="margin-top:10px" class="product-card">
            <el-image :src="product.imgUrl" class="image" fit="cover" :preview-src-list="product.srcList"></el-image>
            <div style="text-align:left;padding:10px">
              <span style="font-weight:600; font-size:16px;">{{product.name}}</span>
              <el-button style="font-weight:600; font-size:15px;" type="text" class="button" @click="showCpDetail(product)">详情</el-button>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <a href="/products"><el-button class="btn-product">产品中心<i class="el-icon-right el-icon--right"></i></el-button></a>
    </div>
    <el-dialog title="产品详情" :visible.sync="cpShow" width="1250px" top="50px">
      <el-image class="cp-detail" :src="cpDetail" fit="cover"></el-image>
    </el-dialog>

    <div class="sj-cpzx">
       业务合作 <span class="en-title">Business Cooperation&emsp;&emsp;&emsp;</span>
       <el-divider></el-divider>
    </div>
    <div class="sy-gywm">
      <el-image style="width: 700px; height: 620px; border-radius:20px; margin-top: 10px;" :src="oemImg" fit="cover"></el-image>
      <div class="yw-block">
        <el-carousel trigger="click"
        height="620px"
        style="border-radius: 20px;"
        :autoplay="isAutoPlay"
        @mouseenter.native="isAutoPlay = false"
        @mouseleave.native="isAutoPlay = true">
          <el-carousel-item v-for="(item, index) in dgImgs" :key="index">
            <el-image style="width: 100%; height: 100%" fit="cover" :src="item.imgUrl"></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>

      <div class="link-div">
        <a href="/introduction#business-ym"><el-button class="btn-compMsg">业务合作<i class="el-icon-right el-icon--right"></i></el-button></a>
      </div>
    </div>

    <div class="sj-cpzx">
       新闻资讯 <span class="en-title">Company News</span>
       <el-divider></el-divider>
    </div>
    <div class="sy-gywm">
      <div class="block">
        <el-carousel trigger="click"
        height="480px"
        style="border-radius: 20px;"
        :autoplay="isAutoPlay"
        @mouseenter.native="isAutoPlay = false"
        @mouseleave.native="isAutoPlay = true">
          <el-carousel-item v-for="(item, index) in news" :key="index">
            <el-image style="width: 100%; height: 100%" fit="cover" :src="item.newsImg"></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="news-li">
        <p v-for="(item, index) in news" :key="index">
          <a class="news-link" @click="showDetail(item)"><span>{{item.title}}</span></a>
          <span style="color: #969696;">{{item.mark}}</span>
          <span class="news-date">{{item.time}}</span>
          <el-divider></el-divider>
        </p>
      </div>
    </div>
    <div class="link-div">
      <a href="/news"><el-button class="btn-compNews">新闻资讯<i class="el-icon-right el-icon--right"></i></el-button></a>
    </div>
    <el-dialog title="资讯详情" :visible.sync="dialogTableVisible" width="1250px" top="30px">
      <iframe :src="htmlContent" width="100%" height="780px" frameborder="no"></iframe>
    </el-dialog>

    <div class="sj-cpzx">
       关于我们 <span class="en-title">About Us&emsp;&emsp;&emsp;</span>
       <el-divider></el-divider>
    </div>
    <div class="sy-gywm">
      <div class="block">
        <el-carousel trigger="click"
        height="480px"
        style="border-radius: 20px;"
        :autoplay="isAutoPlay"
        @mouseenter.native="isAutoPlay = false"
        @mouseleave.native="isAutoPlay = true">
          <el-carousel-item v-for="(item, index) in introductImgs" :key="index">
            <el-image style="width: 100%; height: 100%" fit="cover" :src="item.imgUrl"></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="news-li">
        <div style="white-space: pre-wrap; line-height:40px;">{{introduction}}</div>
      </div>
    </div>
    <div class="link-div">
      <a href="/introduction"><el-button class="btn-compMsg">公司简介<i class="el-icon-right el-icon--right"></i></el-button></a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      isAutoPlay: true,
      listImgs: [],
      introductImgs: [],
      dialogTableVisible: false,
      carHigh: '',
      cpShow: false,
      cpDetail: '',
      htmlContent: '',
      introduction: '',
      products1: [],
      products2: [],
      news: [],
      oemImg: '',
      dgImgs: []
    }
  },
  mounted () {
    let calHeight = 0.41 * screen.width
    if (calHeight > 800) {
      this.carHigh = 0.41 * screen.width + 'px'
    } else {
      this.carHigh = '800px'
    }
    this.$axios.get('/static/index.json').then(res => {
      this.listImgs = res.data.listImgs
      this.introductImgs = res.data.introductImgs
      this.introduction = res.data.introduction
      this.oemImg = res.data.oemImg
      this.dgImgs = res.data.dgImgs
    })
    this.$axios.get('/static/products.json').then(res => {
      this.products1 = res.data.slice(0, 3)
      this.products2 = res.data.slice(3, 6)
    })
    this.$axios.get('/static/news.json').then(res => {
      if (res.data.length > 7) {
        this.news = res.data.slice(0, 7)
      } else {
        this.news = res.data
      }
    })
  },
  methods: {
    showDetail (item) {
      this.dialogTableVisible = true
      this.htmlContent = item.url
      if (item.linkUrl) {
        window.open(item.linkUrl)
        this.dialogTableVisible = false
      }
    },
    showCpDetail (item) {
      this.cpShow = true
      this.cpDetail = item.detail
    }
  }
}
</script>

<style scoped>
.gw{
  width: 100%;
  height: auto;
  text-align: center;
}
.el-carousel {
  margin-top: 2px;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 600px;
  margin: 0;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}
.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
.sj-cpzx {
  width: 1800px;
  height: 60px;
  margin-top: 30px;
  display: inline-block;
  text-align: center;
  color: rgba(9, 124, 170, 0.918);
  font-size: 30px;
}
.link-div {
  width: 1800px;
  height: 85px;
  margin-top: 30px;
  display: inline-block;
  text-align: center;
  color: rgba(9, 124, 170, 0.918);
  font-size: 30px;
}
.sy-gywm {
  width: 1800px;
  height: auto;
  margin-top: 10px;
  display: inline-block;
  text-align: center;
  padding-right: 20px;
}
.en-title {
  font-size: 25px;
  color: rgb(149, 158, 158);
}
.btn-more {
  float: right;
  font-size: 18px;
}
.cartd-bottom {
  margin-top: 15px;
  line-height: 12px;
  padding: 5px;
}
.button {
  padding-top: 5px;
  float: right;
}
.product-card {
    width: 570px;
    height: 355px;
    border: 3px solid #aacef8;
    border-radius: 5px;
    float: left;
    margin-bottom: 20px;
}
.image {
  width: 570px;
  height: 310px;
  display: block;
  border-bottom: 2px solid #aacef8;
}
.btn-product {
  width: 400px;
  height: 50px;
  margin-top: 50px;
  margin-bottom: 5px;
  font-size: 20px;
  border-radius: 10px;
}
.btn-compNews {
  width: 400px;
  height: 50px;
  margin-top: 30px;
  margin-bottom: 5px;
  font-size: 20px;
  border-radius: 10px;
}
.block {
  width: 48%;
  margin-top: 20px;
  float: left;
}
.news-li{
  width: 50%;
  margin-top: 10px;
  display: inline-block;
  height: 480px;
  text-align: left;
  margin-left: 2%;
}
.news-date {
  float: right;
  color: #969696;
}
.news-link {
  text-decoration: none;
  color: rgb(0, 0, 0);
}
.news-link :hover {
  color: #409EFF;
  cursor: pointer;
}
.btn-compMsg {
  width: 400px;
  height: 50px;
  margin-top: 20px;
  font-size: 20px;
  border-radius: 10px;
}
.cp-detail {
  width: 100%;
  height: auto;
}
.yw-block {
  width: 1040px;
  margin-left: 10px;
  margin-top: 10px;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue